import api from "./api";

/** GET /api/chats — list of 8 thread previews for the current user. */
export async function listChats() {
  const { data } = await api.get("/api/chats");
  return data;
}

/** GET /api/chats/{agent_id} — { thread, messages: [...] } */
export async function getChat(agentId) {
  const { data } = await api.get(`/api/chats/${agentId}`);
  return data;
}

/**
 * POST /api/chats/{agent_id}/messages — append user msg, run LLM, return
 * { user_message, agent_message }.
 */
export async function sendChatMessage(agentId, content) {
  const { data } = await api.post(`/api/chats/${agentId}/messages`, { content });
  return data;
}

/** DELETE /api/chats/{agent_id} — clears the thread. 204. */
export async function clearChat(agentId) {
  await api.delete(`/api/chats/${agentId}`);
  return true;
}

/**
 * POST /api/chats/{agent_id}/forward-to-boardroom — creates a Debate seeded
 * with the last 10 messages of this chat. Returns { session_id, goal }.
 */
export async function forwardChatToBoardroom(agentId, goal) {
  const body = goal ? { goal } : {};
  const { data } = await api.post(`/api/chats/${agentId}/forward-to-boardroom`, body);
  return data;
}
